import HomeScreenBase from "../Base/Screens/Home/HomeScreenBase";
import { LoginScreen } from "../Base/Screens/Login/LoginScreen";
import HomeScreen from "../Screen/Home/HomeScreen";

import ComunicadoPDF from "../Screen/Gerencia/Comunicados/PDF/ComunicadoPDF";


import PDFTemplate from "../Componentes/PDF/PDFTemplate"
import RequisasComprasReporte from "../Screen/Compras/Requisas/Reporte/RequisasComprasReporte"

import AutorizarRequisasMantenimientoScreen from '../Screen/Mantenimiento/Requisas/AutorizarRequisasMantenimientoScreen';
import InventarioMantenimientoScreen from '../Screen/Mantenimiento/Inventario/InventarioMantenimientoScreen';
import RequisasMaterialesPendientesDespachoScreen from '../Screen/Mantenimiento/Requisas/RequisasMaterialesPendientesDespachoScreen';



import ServiciosMotoristasScreen from '../Screen/Logistica/Motoristas/ServiciosMotoristasScreen'
import RequisasCombustibleScreen from '../Screen/Logistica/Combustible/RequisasCombustibleScreen'
import ProgramacionVisitasScreen from '../Screen/Logistica/Visitas/ProgramacionVisitasScreen'


import EvaluacionPersonalReporte from '../Screen/RRHH/Evaluacion/EvaluacionPersonalReporte';
import OrdenesComprasReporte from '../Screen/Compras/Ordenes/Reporte/OrdenesComprasReporte';
import InscripcionProveedores from '../Base/Screens/Proveedores/InscripcionProveedores';
import ConfirmacionScreen from '../Base/Screens/Proveedores/ConfirmacionScreen';
// import InscripcionProveedores from '../Screen/Compras/Proveedores/InscripcionProveedores';
import FormatoInscripcionProveedors from '../Base/Screens/Proveedores/FormatoInscripcionProveedor';

import EncuestaClimaLaboralScreen from '../Screen/Externo/Encuestas/RRHH/ClimaLaboral/EncuestaClimaLaboralScreen';
import EncuestaEnd from '../Screen/Externo/Encuestas/End/EncuestaEnd';

import EvaluacionScreen from '../Screen/Gerencia/Procedimientos/Evaluaciones/EvaluacionScreen';
import FormatoInscripcionClientes from '../Base/Screens/Clientes/FormatoInscripcionClientes'
import InscripcionClientes from '../Base/Screens/Clientes/InscripcionClientes';
import FinLinkInscripciónClientes from '../Base/Screens/Clientes/FinLinkInscripciónClientes'



import ITRoutes from './Routes/ITRoutes'
import PlanningRoutes from './Routes/PlanningRoutes'
import RRHHRoutes from './Routes/RRHHRoutes'
import VentasRoutes from './Routes/VentasRoutes'
// import FinanzasRoutes from './Routes/FinanzasRoutes'
import OrganigramaScreen from "../Screen/RRHH/Organigrama/Organigrama/OrganigramaScreen";
import ProductionRoutes from "./Routes/ProductionRoutes";
import GerenciaRoutes from "./Routes/GerenciaRoutes";
import ComprasRoutes from "./Routes/ComprasRoutes";
import FinanzasRouters from "./Routes/FinanzasRouters";
import DesarrolloRoutes from './Routes/DesarrolloRoutes'
import InventarioRoutes from './Routes/InventarioRoutes'

import CarrouselScreen from "../Screen/Externo/Carousel/CarouselScreen";
import KPIsGerenciaScreen from "../Screen/Gerencia/KPIs/KPIsGerenciaScreen";
import ClientesScreen from '../Base/Screens/Clientes/ClientesScreen'
import ProformaInvoice from "../Base/Screens/Clientes/ProformaInvoice/ProformaInvoiceScreen";

import IngresosBodegaMaterialesScreen from '../Screen/Mantenimiento/IngresosMantenimiento/IngresosBodegaMaterialesScreen'
import QRVisitas from "../Screen/Logistica/Visitas/QR/QRVisitas";
import NotasCreditoScreen from "../Screen/Imex/NotasCreditoScreen";
import DyeingMachineWorkflow from "../Screen/Produccion/Dyeing/DyeingMachineWorkflow";

import MantenimientoRoutes from './Routes/MantenimientoRoutes'

export const AppRoutes = {
  rutasOut: [
    {
      path: 'login',
      element: <LoginScreen />
    },
    {
      path: 'Memo/Preview/:memo',
      element: <ComunicadoPDF />
    },
    {
      path: 'ServiciosMotoristas/:token',
      element: <ServiciosMotoristasScreen />
    },
    {
      path: 'InscripcionProveedor/:lang/:Token',
      element: <InscripcionProveedores />
    },
    {
      path: 'Confirmacion/:lang',
      element: <ConfirmacionScreen />
    },
    {
      path: 'FormatoInscripcionProveedor/:Numero/:lang/:Token',
      element: <PDFTemplate ComponentToPrint={FormatoInscripcionProveedors} />
    },
    {
      path: 'OrganigramaCamden',
      element: <OrganigramaScreen Camden={true} />,
    },
    {
      path: 'Memo/Preview/:memo',
      element: <ComunicadoPDF />
    },
    {
      path: 'carousel',
      element: <CarrouselScreen />
    },
    {
      path: 'carousel/1',
      element: <CarrouselScreen />
    },
    {
      path: 'encuesta/ClimaLaboral/:IdEncuesta',
      element: <EncuestaClimaLaboralScreen />
    },
    {
      path: 'encuesta/QR/:IdEncuesta/:CodigoLink',
      element: <EncuestaClimaLaboralScreen QR={true} />
    },
    {
      path: 'encuesta/QR/:IdEncuesta',
      element: <EncuestaClimaLaboralScreen QR={false} />
    },
    {
      path: 'encuesta/End',
      element: <EncuestaEnd />
    },
    {
      path: 'Procedimientos/Evaluaciones/:IdEvaluacion',
      element: <EvaluacionScreen />,
    },
    {
      path: 'FormatoInscripcionClientes/:IdCustomer/:Token/:Idioma',
      element: <FormatoInscripcionClientes />
    },
    {
      path: 'inscripcionClientes/:lang/:Token',
      element: <InscripcionClientes />
    },
    {
      path: 'inscripcionClientes/:lang/:token/Complete',
      element: <FinLinkInscripciónClientes />,
    },
    {
      path: 'proformaInvoice/:token',
      element: <ProformaInvoice />
    },
    {
      path: 'QRVisitas/:NoVisita',
      element: <QRVisitas />
    },
  ],
  rutasIn: [
    {
      path: 'encuesta/QR/:IdEncuesta/:CodigoLink',
      element: <EncuestaClimaLaboralScreen QR={true} />
    },
    {
      path: 'encuesta/End',
      element: <EncuestaEnd />
    },
    {
      path: 'Memo/Preview/:memo',
      element: <ComunicadoPDF />
    },
    {
      path: 'PurchaseRequest/print/:Numero',
      element: <PDFTemplate permiso={3} ComponentToPrint={RequisasComprasReporte} /> // 3 = Compras
    },
    {
      path: 'OrdenCompras/print/:Numero/:Idioma',
      element: <OrdenesComprasReporte /> // 3 = Compras
    },
    {
      path: 'RRHH/Organigrama/Print/:Numero/:Seccion',
      element: <PDFTemplate ComponentToPrint={OrganigramaScreen} />,
    },
    {
      path: 'RRHH/EvaluacionPersonal/:IdEvaluacion',
      element: <EvaluacionPersonalReporte />,
    },
    {
      path: 'InscripcionProveedor/:lang/:Token',
      element: <InscripcionProveedores />
    },
    {
      path: 'Confirmacion/:lang',
      element: <ConfirmacionScreen />
    },
    {
      path: 'FormatoInscripcionProveedor/:Numero/:lang/:Token',
      element: <PDFTemplate ComponentToPrint={FormatoInscripcionProveedors} />
    },
    {
      path: 'Procedimientos/Evaluaciones/:IdEvaluacion',
      element: <EvaluacionScreen />,
    },
    {
      path: 'inscripcionClientes/:lang/:Token',
      element: <InscripcionClientes />
    },
    {
      path: 'inscripcionClientes/:lang/:token/Complete',
      element: <FinLinkInscripciónClientes />,
    },
    {
      path: 'Gerencia/DashboardPPF',
      permiso: 68,
      element: <KPIsGerenciaScreen />
    },
    {
      path: 'FormatoInscripcionClientes/:IdCustomer/:Token/:Idioma',
      element: <FormatoInscripcionClientes />
    },
    {
      path: 'inscripcionClientes/:lang/:Token',
      element: <InscripcionClientes />
    },
    {
      path: 'proformaInvoice/:token',
      element: <ProformaInvoice />
    },
    {
      path: 'QRVisitas/:NoVisita',
      element: <QRVisitas />
    },
    {
      path: 'Produccion/DyeingMachineWorkflow',
      permiso: 146,
      element: <DyeingMachineWorkflow />,
    },
  ],

}

export const rutasDashboard = [
  // HOME
  {
    path: 'Home',
    permiso: 1,
    element: <HomeScreenBase HomeScreen={HomeScreen} />
  },

  // IT
  ...ITRoutes,

  // GERENCIA
  ...GerenciaRoutes,

  // COMPRAS
  ...ComprasRoutes,

  // Finanzas
  ...FinanzasRouters,

  // INVENTARIO
  ...InventarioRoutes,

  // VENTAS
  ...VentasRoutes,


  ...MantenimientoRoutes,  

  // Matemimiento
  {
    path: 'Mantenimiento/AprobarMaterialesMantenimiento',
    permiso: 73,
    element: <AutorizarRequisasMantenimientoScreen />,
  },
  {
    path: 'Mantenimiento/ListadoRequisasMantenimiento',
    permiso: 74,
    element: <AutorizarRequisasMantenimientoScreen />,
  },
  {
    path: 'Mantenimiento/Inventario',
    permiso: 37,
    element: <InventarioMantenimientoScreen />,
  },

  {
    path: 'Mantenimiento/AutorizarMASS',
    permiso: 64,
    element: <AutorizarRequisasMantenimientoScreen />,
  },
  {
    path: 'Mantenimiento/PendienteDespacho',
    permiso: 58,
    element: <RequisasMaterialesPendientesDespachoScreen />,
  },
  {
    path: 'Mantenimiento/AutorizarRequisasMantenimiento',
    permiso: 57,
    element: <AutorizarRequisasMantenimientoScreen />,
  },
  {
    path: 'Mantenimiento/Ingresos',
    permiso: 49,
    // element: <IngresosMantenimiento />,
    element: <IngresosBodegaMaterialesScreen />
  },

  // Logistica

  {
    path: 'Logistica/ServicioMotorista',
    permiso: 70,
    element: <ServiciosMotoristasScreen />,
  },
  {
    path: 'Logistica/RequisasCombustible',
    permiso: 76,
    element: <RequisasCombustibleScreen />,
  },
  {
    path: 'Logistica/Visitas',
    permiso: 82,
    element: <ProgramacionVisitasScreen />,
  },

  //Ventas

  {
    path: 'Finanzas/Clientes',
    permiso: 52,
    element: <ClientesScreen Finanzas={false} />,
  },

  //Produccion
  ...ProductionRoutes,


  // PLANEACION
  ...PlanningRoutes,

  // RRHH
  ...RRHHRoutes,

  //DESARROLLO
  ...DesarrolloRoutes,

  //IMEX
  {
    path: 'Imex/NotasCredito',
    permiso: 105,
    element: <NotasCreditoScreen />,
  },
]